module.exports = __webpack_public_path__ + "img/banner.46963447.gif";